import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { Produto } from 'src/app/_models';
import { Message } from '../../_models/Message';
import { ProdutoService } from 'src/app/_services/produto.service';
import { TipoPesquisaProduto } from 'src/app/_common/enums';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { PopupMessagesNewStyleTestComponent } from '../popup-messages-new-style-test/popup-messages-new-style-test.component';

@Component({
  selector: 'app-popup-produtos',
  templateUrl: './popup-produtos.component.html',
  styleUrls: ['./popup-produtos.component.css']
})
export class PopupProdutosComponent implements OnInit {
  produtos: Produto[];
  produtoSelecionado: Produto;
  displayedColumns: string[] = ['select', 'cnae', 'codigoMaterial', 'descricao', 'contacontabil', 'contrato', 'ipi'];
  dataSource = new MatTableDataSource<Produto>(new Array<Produto>());
  selection = new SelectionModel<Produto>(true, []);
  termoPesquisaProduto: string;
  tipoBusca = 'R';
  tipoPesquisa: TipoPesquisaProduto;
  fornecedor: string;
  tipoDocumento: number;
  prodForm: FormGroup;

  messageModel: Message;
  showProgressBar = false;

  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  constructor(
    private dialogRef: MatDialogRef<PopupProdutosComponent>,
    private produtoService: ProdutoService,
    private dialog: MatDialog,
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) data
  ) {
    this.fornecedor = data.fornecedor;
    this.tipoDocumento = data.tipoDocumento;
  }

  ngOnInit() {
    this.prodForm = this.formBuilder.group({
      frmTipoPesquisa: ['', Validators.required],
      frmDescProduto: ['', Validators.required],
      frmTipoBusca: ['', Validators.required]
    });
  }

  pesquisar() {
    this.showProgressBar = true;
    this.produtoService.buscarProdutoRecorrente(
      this.termoPesquisaProduto,
      this.tipoBusca,
      this.fornecedor,
      this.tipoDocumento,
      Number(this.tipoPesquisa)).subscribe(ret => {
        const retorno = ret.data;
        if (retorno.success) {
          this.produtos = retorno.data;
          this.CarregarProdutos();
        } else {
          this.ExibeMensagem('', retorno.message, 'warning');
        }
        this.showProgressBar = false;
      }
    );
  }


  ExibeMensagem(title: string, message: string, status: string = null) {
    this.messageModel = new Message(title, '', `${message} `, status);
    return this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
  }


  CarregarProdutos() {
    if (this.produtos) {
      this.dataSource = new MatTableDataSource<Produto>(this.produtos);
    }
    this.dataSource.paginator = this.paginator;
  }

  incluirProdutos() {
    this.dialogRef.close(this.selection.selected);
  }

  closePopup() {
    this.dialogRef.close('');
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  // Controle Select
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: Produto, index?: number): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${index + 1}`;
  }

}
